import CreateTransfer from './CreateTransfer';
import ConnectedCreateTransfer from './ConnectedCreateTransfer';

export { CreateTransfer };
export default ConnectedCreateTransfer;
